document.addEventListener("DOMContentLoaded", function () {
  console.log("JS Loaded and Ready!"); // Check if the script is running

  const starrySky = document.querySelector(".starry-sky");
  const numStars = 400; // Number of stars to create

  // Create stars dynamically
  for (let i = 0; i < numStars; i++) {
    const star = document.createElement("div");
    star.classList.add("star");

    // Random position for each star
    const xPosition = Math.random() * 100; // Random X position
    const yPosition = Math.random() * 100; // Random Y position

    star.style.left = `${xPosition}%`;
    star.style.top = `${yPosition}%`;

    // Randomize animation delay and duration for each star
    const delay = Math.random() * 2 + "s"; // Random delay between 0-2 seconds
    const duration = Math.random() * 2 + 2 + "s"; // Random duration between 2-4 seconds

    star.style.animationDelay = delay;
    star.style.animationDuration = duration;

    starrySky.appendChild(star);
  }
});
